import { render, staticRenderFns } from "./AxisYTitle.vue?vue&type=template&id=09db4bad&scoped=true&"
import script from "./AxisYTitle.vue?vue&type=script&lang=ts&"
export * from "./AxisYTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AxisYTitle.vue?vue&type=style&index=0&id=09db4bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db4bad",
  null
  
)

export default component.exports